'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sections = require('./sections/sections');

var _sections2 = _interopRequireDefault(_sections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [
//    page,
_sections2.default]; //import page from './pages/pages';


//////////////////
// WEBPACK FOOTER
// ./app/modules/modules.config.js
// module id = 17
// module chunks = 0